import { Component, OnInit, OnChanges } from '@angular/core';
import { LoggerService } from 'src/shared/logger/logger.service';
import { Levels } from 'src/shared/logger/levels.enum';
import { HomeService } from '../shared/home.service';

@Component({
  selector: 'app-total-units-added-date-graph',
  templateUrl: './added-units-graph.component.html',
  styleUrls: ['./added-units-graph.component.css']
})
export class AddedUnitsGraphComponent implements OnInit {
  //the received data to be drawn on chart
  public lineChartData1: Array<{ data: number[], label: string }> = [{ data: [0], label: 'no. of units added' }];
  //the received labels to be shown on x-axis
  public lineChartLabels1: Array<string> = ["1-2021"];
  //chart options
  public lineChartOptions1 = {
    scales: {
      yAxes: [
        {
          ticks: {
            beginAtZero: true
          },
          gridLines: {
            color: 'rgba(0, 0, 0, 0.1)'
          }
        }
      ],
      xAxes: [
        {
          gridLines: {
            color: 'rgba(0, 0, 0, 0.1)'
          }
        }
      ]
    },
    lineTension: 10,
    responsive: true,
    maintainAspectRatio: false,
    elements: { line: { tension: 0 } }
  };
  //chart colors
  public lineChartColors1: Array<object> = [
    {
      // grey
      backgroundColor: 'rgba(6,215,156,0.0)',
      borderColor: 'rgba(57,139,247,1)',
      pointBackgroundColor: 'rgba(57,139,247,1)',
      pointBorderColor: '#fff',
      pointHoverBackgroundColor: '#fff',
      pointHoverBorderColor: 'rgba(57,139,247,0.5)'
    },
    {
      // dark grey
      backgroundColor: 'rgba(57,139,247,0.0)',
      borderColor: 'rgba(57,139,247,1)',
      pointBackgroundColor: 'rgba(57,139,247,1)',
      pointBorderColor: '#fff',
      pointHoverBackgroundColor: '#fff',
      pointHoverBorderColor: 'rgba(57,139,247,0.5)'
    }
  ];
  public lineChartLegend1 = false;
  public lineChartType1 = 'line';

  constructor(private loggerService: LoggerService,
    private homeService: HomeService) {
  }
  ngOnInit(): void {
    this.homeService.dataToBeTransmitted.subscribe(data => {
      this.lineChartData1[0].data = [0];
      this.lineChartLabels1 = ["1-2021"];
      data?.addedUnitsGraphData.forEach(i => this.lineChartLabels1.push(i.Month.toString() + '-' + i.Year))
      data?.addedUnitsGraphData.forEach(i => this.lineChartData1[0].data.push(this.lineChartData1[0].data[this.lineChartData1[0].data.length - 1] + i.count))
    })
  }

}
